import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import { TextInputWrapper, TextInput as TextInput$2, TextInputIcon, ValidationText } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ICON_UI_CHECKMARK } from '../../icons/ICON_UI_CHECKMARK.js';
import { ICON_UI_WARNING } from '../../icons/ICON_UI_WARNING.js';

var _excluded = ["hasError", "onChange", "validationText", "isValid", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TextInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    onChange = _ref.onChange,
    _ref$validationText = _ref.validationText,
    validationText = _ref$validationText === void 0 ? '' : _ref$validationText,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    id = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  var showValidationText = hasError && validationText !== undefined;
  var validationAriaId = id !== undefined ? "".concat(id, "-validation") : undefined;
  return /*#__PURE__*/jsxs(TextInputWrapper, {
    children: [/*#__PURE__*/jsx(TextInput$2, _objectSpread(_objectSpread({}, rest), {}, {
      id: id,
      onChange: onChange
      // @ts-expect-error
      ,
      $hasError: hasError,
      $isValid: isValid,
      "aria-invalid": hasError,
      "aria-describedby": showValidationText ? validationAriaId : undefined,
      ref: ref
    })), isValid && /*#__PURE__*/jsx(TextInputIcon, {
      path: ICON_UI_CHECKMARK,
      size: "s"
    }), hasError && /*#__PURE__*/jsx(TextInputIcon, {
      path: ICON_UI_WARNING,
      size: "s",
      $hasError: true
    }), hasError && validationText && /*#__PURE__*/jsx(ValidationText, {
      id: validationAriaId,
      children: validationText
    })]
  });
});
TextInput.displayName = 'TextInput';
// @ts-expect-error
TextInput.defaultProps = {
  hasError: false,
  validationText: '',
  isValid: false
};
var TextInput$1 = TextInput;

export { TextInput$1 as default };
//# sourceMappingURL=TextInput.js.map
